import React from 'react';
import { Link } from 'react-router-dom';
import s from './Button.scss';

const Button = ({ href, text, appearance = 'button__outline', disabled = false }) => {
	if (href !== undefined) {
		if (href.indexOf('://') !== -1) {
			return <a href={href} className={[s.button, s[appearance]].join(' ')}>{text}</a>;
		}
		return <Link to={href} className={[s.button, s[appearance]].join(' ')}>{text}</Link>;
	}
	return <button disabled={disabled} className={[s.button, s[appearance]].join(' ')}>{text}</button>;
};

export default Button;



// WEBPACK FOOTER //
// ./components/Parts/Button.jsx